import React from 'react';
import InputMask from 'react-input-mask';

import Input from './Input';

const MaskedInput = props => {
  this.customRegexes = {
    'm': '[0-2]',
    'M': '[1-2]',
    '9': '[0-9]'
  };

  return (
    <InputMask
      formatChars={this.customRegexes}
      mask='mM / 99'
      maskChar=" "
      {...props}
    >
      {inputProps => <Input {...inputProps} /> }
    </InputMask>
  );
};

export default MaskedInput;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/MaskedInput.js